import React, { useEffect } from "react";
import { requestAccessToken } from "helpers/Auth";
import LoaderShell from "components/LoaderShell";

export default function AuthorizeScreen() {
    // This should only run once, when called directly in response
    // to an authorization request.
    useEffect(() => {
        const u = new URL(window.location);
        if (u.searchParams.get("code") && u.searchParams.get("state")) {
            requestAccessToken(
                u.searchParams.get("code"),
                u.searchParams.get("state")
            ).then((token) => {
                if (token) {
                    window.location.href = u.searchParams.get("continue")
                        ? u.searchParams.get("continue")
                        : "/app";
                } else {
                    console.error("Failed to get access token");
                }
            });
        }
    }, []);

    return <LoaderShell />;
}
